import { Customer } from "../types";

export function getCustomerFio(customer: Customer) {
  return `${customer.last_name || ''} ${customer.first_name || ''} ${customer.middle_name || ''}`
}
